<template>
  <div
    class="p-grid element-grid"
    :class="bindingClass"
    :style="{ margin: margin, padding: padding, height: height }"
  >
    <slot />
  </div>
</template>
<script lang="ts">
import { Options } from "vue-class-component";
import BaseTag from "../BaseTag.vue";
@Options({
  name: "IziGrid",
  props: ["class", "padding", "margin", "height"]
})
export default class IziGrid extends BaseTag {}
</script>

<style lang="scss" scoped>
.p-grid {
  margin: 0px;
  padding: 0px;
}
</style>
